import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormsModule, ReactiveFormsModule, UntypedFormGroup, Validators} from "@angular/forms";
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {FormOptionsLists} from "../../../shared/FormOptionsLists";
import {MatOptionModule} from "@angular/material/core";
import {MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {TextPatternService} from "../../../services/text/text-pattern.service";
import {TextPatternCreationDto} from "../../../dtos/text/text-pattern-dto";
import {NotificationService} from "../../../services/common/notification.service";
import {MatButtonModule} from "@angular/material/button";

@Component({
  selector: 'app-new-text-pattern',
  imports: [
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatButtonModule,
  ],
  templateUrl: './new-text-pattern.component.html',
  styleUrl: './new-text-pattern.component.scss'
})
export class NewTextPatternComponent implements OnInit{

  formOptionsLists = new FormOptionsLists();
  modesList = this.formOptionsLists.modes;

  textPatternFormGroup!: UntypedFormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<NewTextPatternComponent>,
    private textPatternService: TextPatternService,
    private notificationService: NotificationService,
  ) {}


  ngOnInit(): void {
    // Initialize form controls
    this.textPatternFormGroup = this.fb.group({
      nameCtrl: ['', Validators.required],
      mode: [this.modesList[0], Validators.required],
    });

  }

  createTextPattern(): void {
    if (this.textPatternFormGroup.valid) {
      const result: TextPatternCreationDto = {
        id: null,
        name: this.textPatternFormGroup.value.nameCtrl,
        mode: this.textPatternFormGroup.value.mode,
        content: 'Verändere mich!',
        vocabCategoryIds: [],
        vocabEntryIds: [],
        functionalGrammarCategoryIds: [],
        functionalGrammarEntryIds: [],
        systemicGrammarCategoryIds: [],
        systemicGrammarEntryIds: [],
        textPatternIds: [],
        textTypeIds: [],
        detailedCanDoStatementCategoryIds: [],
        detailedCanDoStatementEntryIds: [],
        globalCanDoStatementCategoryIds: [],
        globalCanDoStatementEntryIds: []
      };
      this.textPatternService.createTextPattern(result).subscribe({
        next: (data) => {
          this.dialogRef.close(data);
        },
        error: (error) => {
          this.notificationService.openSnackBar(error);
        }
      })
    }
  }



}
